<ui-title [title]="'System Access Report'">

	<div class="col-lg-6 float-right">
		<ui-loading [loadingText]="'loading reports'" [loading]="reports.loading"></ui-loading>
	</div>
</ui-title>
<ui-download #downloader></ui-download>
<div class="col-lg-8">
	<ui-table
		[chunker]="reports.chunker" (chunked)="reports.chunkedData = $event"
		[headers]="[
			{id: 'Name', label: 'Report',sortable:true},
			{id: 'Year', label: 'Year',  exactMatch: false,sortable:true},
			{id: 'StatusId', label: 'Status',sortable:true},
			{id: 'CreatedDate', label: 'Date Opened',sortable:true},
			{id: 'ClosedDate', label: 'Date Closed',sortable:true}
			]"
	>
		<tr *ngFor="let report of reports.chunkedData"
			[class]="reports.selectedId==report.Id?'helper-clickable active':'helper-clickable'"
			(click)="onReportRowClick(report)"
		>
			<td>{{report.Name}}</td>
			<td>{{report.Year}}</td>
			<td class="helper-capitalize">{{report.StatusId}}</td>
			<td>{{report.CreatedDate|date}}</td>
			<td>{{report.ClosedDate|date}}</td>
		</tr>
	</ui-table>
</div>


<div class="col-lg-12 mt-4" *ngIf="reports.selectedId">
	<ui-loading [loadingText]="'loading report'" [loading]="report.loading"></ui-loading>

	<div *ngIf="reports.selected">
		<h2>{{reports.selected.Name}} {{reports.selected.Year}} System Access Report
		</h2>

		<ui-table #tableComponent

			[chunker]="report.chunker" (chunked)="report.chunkedData = $event"
			[headers]="[
				  {id: 'SystemName', label: 'System', filterable: true,sortable:true},
			{id: 'UserFirstName', label: 'User First Name', filterable: true,sortable:true},
			{id: 'UserLastName', label: 'User Last Name', filterable: true,sortable:true},
			{id: 'SystemRoleMappedName', label: 'Role', filterable: true,sortable:true},
			{id: '', label: 'Approver Name',idFunction: report_idFunctionApprover, filterable: true,sortable:true},
			{id: 'ApprovalDate', label: 'Date Decision', filterable: true,type:'date',sortable:true},
			{id: 'CounterSignDate', label: 'Date Countersigned', filterable: true,type:'date',sortable:true}
				  ]"
			[filters]="true">
			<tr *ngFor="let d of report.chunkedData"
			>
				<td>{{d.SystemName}}</td>
				<td>{{d.UserFirstName}}</td>
				<td>{{d.UserLastName}}</td>
				<td>{{d.SystemRoleMappedName}}</td>
				<td>
					{{d.ApproverFirstName}}
					{{d.ApproverLastName}}
				</td>
				<td>
					{{d.ApprovalDate|date}}
				</td>
				<td>{{d.CounterSignDate|date}}</td>
			</tr>
		</ui-table>

		<button class="btn btn-primary btn-sm float-right mt-4" (click)="report_openInExcel()">Export to Excel</button>
	</div>
</div>
